import React, { Component } from 'react';
import { Paper, Typography, Button, Box, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom'; // Import withRouter
import FadeInSection from '../useInView';

const data = [
    {
        title: 'IT Wizzards',
        preview: 'Custom software, networking, IoT, cyber security, CCTV.',
        text: 'Build secure, scalable systems and discover how we modernize your stack.',
        target: 'target-1',
        cta: 'DISCOVER MORE',
    },
    {
        title: 'Design Dreamers',
        preview: 'Brand identity, graphics, UI/UX, creative systems.',
        text: 'Make your brand unforgettable with design that converts and connects.',
        target: 'target-2',
        cta: 'DISCOVER MORE',
    },
    {
        title: 'Media Masters',
        preview: 'Photo, video, content production, event coverage.',
        text: 'Turn ideas into content that performs across campaigns and events.',
        target: 'target-3',
        cta: 'DISCOVER MORE',
    },
    {
        title: 'Printology',
        preview: 'Printing, 3D printing, laser engraving.',
        text: 'Precision print and fabrication made to showcase your brand.',
        href: 'https://printology.robotics-media.com',
        cta: 'DISCOVER MORE',
    },
];
export function withRouter(Component) {
    return function WrapperComponent(props) {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    };
}
class ServicesComponent extends Component {
    handleNavigateAndScroll = (target) => {
        // Use navigate from props
        this.props.navigate('/services');

        setTimeout(() => {
            const element = document.getElementById(target);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 0);
    };

    render() {
        return (
            <Container sx={{ width: '100%' }}>
                <FadeInSection>
                    <Typography className='fadeInLeftToRight' variant="code" fontSize='2.5rem' fontFamily='PT Mono' color='white' align="flex-start"> Our Services </Typography>
                </FadeInSection>
                <Box sx={{ mt: 2, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', md: 'center' }, gap: 2 }}>
                    {/* <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.8)', maxWidth: '700px' }}>
                        A quick preview of our core capabilities, with dedicated pathways to explore every service in depth.
                    </Typography> */}
                    <Box sx={{ border: '1px solid rgba(255, 255, 255, 0.5)', borderRadius: '999px', px: 2.5, py: 1, bgcolor: 'rgba(0, 0, 0, 0.4)' }}>
                        <Typography variant="body2" sx={{ color: 'white', fontFamily: 'PT Mono, monospace', letterSpacing: '0.08em' }}>
                            HIKVISION PARTNER
                        </Typography>
                    </Box>
                </Box>
                <Box style={{ height: '50px' }} />
                <Box sx={{

                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' }, // Stack on small screens, row on medium and up
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: 8, // Add gap between items for all screen sizes
                }}>
                    {data.map((item) => (
                        <FadeInSection key={item.title}>
                            <Paper
                                sx={{
                                    p: 2,
                                    bgcolor: 'rgba(0, 0, 0, 0.5)',
                                    borderRadius: '20px',
                                    border: '1px solid white',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    color: 'white',
                                    height: '360px',
                                    width: '250px',
                                    textAlign: 'center',
                                    textJustify: 'auto',
                                }}
                            >
                                <Typography variant="h5" fontSize='2rem' marginTop='20px' component="h4"  >{item.title}</Typography>

                                <Box sx={{ px: 1, flexGrow: 1, display: 'flex', alignItems: 'center' }}>
                                    <Typography variant="code" className='code-element'>
                                        <Box component="span" sx={{ fontWeight: 600 }}>
                                            {item.preview}
                                        </Box>{' '}
                                        {item.text}
                                    </Typography>
                                </Box>
                                <Button
                                    variant="contained"
                                    sx={{
                                        mt: 2,
                                        bgcolor: 'white',
                                        color: 'black',
                                        fontFamily: 'PT Mono, monospace',
                                        fontWeight: 'bold',
                                        fontSize: '1.2rem',
                                        width: '200px',
                                        height: '40px',
                                        borderRadius: '10px',
                                        '&:hover': {
                                            bgcolor: 'white',
                                            opacity: 0.9,
                                        },
                                    }}
                                    component={item.href ? 'a' : 'button'}
                                    href={item.href || undefined}
                                    target={item.href ? '_blank' : undefined}
                                    rel={item.href ? 'noreferrer' : undefined}
                                    onClick={item.href ? undefined : () => this.handleNavigateAndScroll(item.target)}
                                >
                                    {item.cta}
                                </Button>
                            </Paper>
                        </FadeInSection>
                    ))}
                </Box>
                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
                    <Button
                        variant="contained"
                        href="/services"
                        sx={{
                            bgcolor: 'white',
                            color: 'black',
                            fontFamily: 'PT Mono, monospace',
                            fontWeight: 'bold',
                            borderRadius: '10px',
                            '&:hover': { bgcolor: 'white', opacity: 0.9 },
                        }}
                    >
                        SEE ALL SERVICES
                    </Button>
                    <Button
                        variant="outlined"
                        href="https://printology.robotics-media.com"
                        target="_blank"
                        rel="noreferrer"
                        sx={{
                            color: 'white',
                            borderColor: 'white',
                            fontFamily: 'PT Mono, monospace',
                            fontWeight: 'bold',
                            borderRadius: '10px',
                            '&:hover': { borderColor: 'white', opacity: 0.9 },
                        }}
                    >
                        PRINTOLOGY
                    </Button>
                </Box>
            </Container>
        );
    }
}

export default withRouter(ServicesComponent);
